export default __webpack_public_path__ + "cd6d6a25dee0642f4624bf427093eece.png";